// StatusBar.js
// Simple status bar for VS Code-like IDE
import React from 'react';

const StatusBar = ({ status = 'Ready', file = '', line = 1, col = 1, model = 'gpt-4o' }) => (
  <div style={{
    height: 28,
    background: '#232323',
    color: '#b3b3b3',
    display: 'flex',
    alignItems: 'center',
    fontSize: 13,
    padding: '0 16px',
    borderTop: '1px solid #222',
    justifyContent: 'space-between',
    position: 'fixed',
    bottom: 0,
    left: 0,
    width: '100vw',
    zIndex: 100,
  }}>
    <span>{status}</span>
    <span>{file && `File: ${file}  `}Ln {line}, Col {col}</span>
    <span>Model: {model}</span>
  </div>
);

export default StatusBar;
